module.exports = __webpack_public_path__ + "5e2de13e664203c8435d2cad89d92298.svg";